import { Box } from "@mui/system";
import { Typography } from "@mui/material";
import { Link } from "react-router-dom";

// import Logo from "assets/images/logo_wc.svg";

const textLogoStyles = {
  color: "#000000",
  fontSize: "22px",
  fontWright: "bold",
  marginLeft: "12px",
  marginRight: "12px",
};

const LogoSection = () => {
  return (
    <Box
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
     
      {
      <Link to="/" style={{ textDecoration: "none" }}>
      <img
        src="appLogo.png"
        alt="plandid"
        style={{ height: "80px", width: "80px", cursor: "pointer" }}
      />
    </Link>
      }
    </Box>
  );
};

export default LogoSection;
